import React, { useState } from 'react';

interface SimpleImageCarouselProps {
  images: string[];
  productCode: string;
  width?: number;
  height?: number;
  className?: string;
}

export function SimpleImageCarousel({ 
  images, 
  productCode, 
  width = 80, 
  height = 80,
  className = ""
}: SimpleImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images || images.length === 0) {
    return (
      <div 
        className={`bg-gray-200 flex items-center justify-center ${className}`}
        style={{ width, height }}
      >
        <span className="text-gray-500 text-xs">No image</span>
      </div>
    );
  }

  if (images.length === 1) {
    return (
      <img
        src={images[0]}
        alt={productCode}
        className={`object-cover ${className}`}
        style={{ width, height }}
      />
    );
  }

  return (
    <div className={`relative ${className}`} style={{ width, height }}>
      {/* Main image */}
      <img
        src={images[currentIndex]}
        alt={`${productCode} - ${currentIndex + 1}`}
        className="w-full h-full object-cover"
      />
      
      {/* Dots navigation */}
      {images.length > 1 && (
        <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex gap-1">
          {images.map((_, index) => (
            <button
              key={index}
              type="button"
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-colors duration-200 ${
                index === currentIndex 
                  ? 'bg-[#262626] border-[1.5px] border-white' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SimpleImageCarousel;